/**
 * Budget Service
 * 예산 관련 모든 API 호출을 중앙화
 */

import { apiClient } from './apiClient';

class BudgetService {
  /**
   * 월별 예산 목록 조회
   * @param {string} month - 조회할 월 (YYYY-MM 형식)
   * @returns {Promise<Array>} 예산 목록 배열
   */
  async getBudgets(month) {
    return apiClient.get(`/api/budgets/${month}`);
  }

  /**
   * 예산 생성
   * @param {object} data - 예산 데이터 (category, amount, month)
   * @returns {Promise<object>} 생성된 예산 데이터
   */
  async createBudget(data) {
    return apiClient.post('/api/budgets', data);
  }

  /**
   * 예산 삭제
   * @param {number} id - 삭제할 예산 ID
   * @returns {Promise<void>}
   */
  async deleteBudget(id) {
    return apiClient.delete(`/api/budgets/${id}`);
  }

  /**
   * 예산 vs 실제 지출 비교 조회
   * @param {string} month - 비교할 월 (YYYY-MM 형식)
   * @returns {Promise<Array>} 예산 비교 데이터 배열
   */
  async getComparison(month) {
    return apiClient.get(`/api/budget-comparison/${month}`);
  }
}

export const budgetService = new BudgetService();
export default budgetService;
